import React, { useEffect } from "react";
import { Icon } from "@iconify/react";
import { useRef, useState } from "react";
import personFill from "@iconify/icons-eva/person-fill";
import unlockFill from "@iconify/icons-eva/unlock-fill";
import { useLocation, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { alpha } from "@mui/material/styles";
import {
  Button,
  Box,
  Divider,
  MenuItem,
  Typography,
  Avatar,
  IconButton,
} from "@mui/material";
import MenuPopover from "../../components/MenuPopover";
import ChangePassword from "./ChangePassword";
import { get_root_value } from "src/utils/domUtils";
import { _get_user_from_localStorage } from "src/DAL/localstorage/LocalStorage";
import { s3baseUrl } from "src/config/config";
import { useContentSetting } from "src/Hooks/ContentSettingState";
import { getForms_count } from "src/DAL/Forms/forms";
import { useChat } from "src/Hooks/ChatContext";

const MENU_OPTIONS = [
  {
    label: "Edit Profile",
    icon: personFill,
    linkTo: "/edit-profile",
  },
];

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [openPasswordModal, setopenPasswordModal] = useState(false);
  const { handleCloseChat } = useChat();
  const {
    userInfo,
    setUserInfo,
    STOP_SOCKET_FORCEFULLY,
    handleUnreadMessageCount,
  } = useContentSetting();

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleProfile = (value) => {
    navigate(value);
    handleClose();
  };

  const handleGetCount = async () => {
    const result = await getForms_count();
    if (result.code === 200) {
      setUserInfo((values) => ({
        ...values,
        formcount: result?.pending_forms,
      }));
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleLogout = async () => {
    STOP_SOCKET_FORCEFULLY();
    handleUnreadMessageCount(0);
    handleCloseChat();
    localStorage.clear();
    navigate("/login");
  };
  useEffect(() => {
    handleGetCount();
  }, [pathname]);

  useEffect(() => {
    setTimeout(() => {
      const is_path_includes = (path) => {
        return pathname.toString().includes(path);
      };
      if (!is_path_includes("/form-list")) {
        localStorage.removeItem("UserFormSListSearch");
      }
      if (!is_path_includes("/form-list/forms")) {
        localStorage.removeItem("userFormFilter");
      }
      if (!pathname.match("/payment-transactions")) {
        localStorage.removeItem("TransactionListSearch");
      }
      if (!pathname.match("/member")) {
        localStorage.removeItem("MemberListSearch");
      }
      if (!pathname.match("/exercise")) {
        localStorage.removeItem("ExercisesListSearch");
      }
      if (!pathname.match("/subscription-list")) {
        localStorage.removeItem("subscription_list_data");
      }
      if (!pathname.match("/forms")) {
        localStorage.removeItem("UserFormSListSearch");
      }
      if (!pathname.match("/workout")) {
        localStorage.removeItem("WorkoutListSearch");
      }
      if (!pathname.match("/member")) {
        localStorage.removeItem("day_calories");
      }
      if (!is_path_includes("/nutrition_library")) {
        localStorage.removeItem("nutrition_library_filter");
      }
      if (!is_path_includes("/workout_library")) {
        localStorage.removeItem("workout_library_filter");
      }
      if (!is_path_includes("/mindset_library")) {
        localStorage.removeItem("mindset_library_filter");
      }
      if (!is_path_includes("/video_library")) {
        localStorage.removeItem("video_library_filter");
      }
      if (!is_path_includes("/mindset_type")) {
        localStorage.removeItem("mindset_type");
      }
      if (!is_path_includes("/nutrition_type")) {
        localStorage.removeItem("nutrition_type");
      }
      if (!is_path_includes("/video_type")) {
        localStorage.removeItem("video_type");
      }
      if (!is_path_includes("/exercises_type")) {
        localStorage.removeItem("exercises_type");
      }
      if (!is_path_includes("/workbook_library")) {
        localStorage.removeItem("workbook_library_filter");
      }
    }, 1000);
  }, [pathname]);

  return (
    <>
      <ChangePassword
        openPasswordModal={openPasswordModal}
        setopenPasswordModal={setopenPasswordModal}
      />
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            "&:before": {
              zIndex: 1,
              content: "''",
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              position: "absolute",
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            },
            color: get_root_value("--portal-theme-primary"),
          }),
        }}
      >
        <Avatar
          className="top-avatar"
          src={s3baseUrl + userInfo?.image?.thumbnail_1}
          alt="photoURL"
        />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {userInfo?.first_name}
            &nbsp;{(" ", userInfo?.last_name)}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: get_root_value("--input-text-color: #fff") }}
            noWrap
          >
            {userInfo?.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            onClick={() => handleProfile(option.linkTo)}
            sx={{ typography: "body2", py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24,
                color: get_root_value("--portal-theme-primary"),
              }}
            />

            {option.label}
          </MenuItem>
        ))}
        <MenuItem
          key=""
          onClick={() => {
            handleClose();
            setopenPasswordModal(true);
          }}
          sx={{ typography: "body2", py: 1, px: 2.5 }}
        >
          <Box
            component={Icon}
            icon={unlockFill}
            sx={{
              mr: 2,
              width: 24,
              height: 24,
              color: get_root_value("--portal-theme-primary"),
            }}
          />
          Change Password
        </MenuItem>

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            fullWidth
            color="inherit"
            variant="outlined"
            onClick={() => handleLogout()}
          >
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
